import type { Volume } from '@/entities/volume';
import type { RequestMeta, ResponseMeta } from '@/shared/api';
import request from '@/shared/api/request';

export const getVolumes = (
  params?: RequestMeta,
): Promise<{ meta: ResponseMeta; volumes: Volume[] }> =>
  request({
    url: '/volumes/',
    params,
  });
